import { createSelector } from 'reselect';
const getDynamicListing = (state) => {
  return state.dynamicListing;
}

export const isDynamicListing = createSelector(
  [getDynamicListing],
  (dynamicListing) => {
    return dynamicListing.isDynamicListing;
  }
);
